//
// ChatAlertContentPoliceSketch - Renders police sketch alert content
//
import PropTypes from 'prop-types';

import { useTownAssets } from '../../../../stores';
import { FormPoliceSketchContent } from '../../forms';

function ChatAlertContentPoliceSketch({
  text,
  fname,
  lname,
  age,
  gender,
  pic,
  picPending,
}) {
  const { assets } = useTownAssets();
  const { translate } = assets;

  return [
    <div key="text">
      <b>{text}</b>
    </div>,

    <FormPoliceSketchContent
      translate={translate}
      key="content"
      fname={fname}
      lname={lname}
      age={age}
      gender={gender}
      pic={pic}
      picPending={picPending}
    />,

    <div key="note">
      <i>
        {translate('refrainContact', 'statements')}
      </i>
    </div>,
  ];
}

ChatAlertContentPoliceSketch.propTypes = {
  text: PropTypes.string,
  fname: PropTypes.string,
  lname: PropTypes.string,
  age: PropTypes.number,
  gender: PropTypes.string,
  pic: PropTypes.string,
  picPending: PropTypes.bool,
};

export default ChatAlertContentPoliceSketch;
